// extracted by mini-css-extract-plugin
module.exports = {"score":"_0ec636e","team":"_986cc78","loading":"_75846f3","unavailable":"_3585a2c","skeleton":"_3f32f00","name":"_a6f6662","inPlay":"_7b87b94"};